export function generateRandomString(length: number = 64): string {
	const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
	const values = new Uint8Array(length);
	if (typeof window !== 'undefined' && window.crypto) {
		window.crypto.getRandomValues(values);
	} else {
		for (let i = 0; i < length; i++) {
			values[i] = Math.floor(Math.random() * 256);
		}
	}
	return Array.from(values)
		.map((v) => possible[v % possible.length])
		.join('');
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
	const encoder = new TextEncoder();
	const data = encoder.encode(verifier);
	let bytes: Uint8Array;
	if (typeof window !== 'undefined' && window.crypto && window.crypto.subtle) {
		const digest = await window.crypto.subtle.digest('SHA-256', data);
		bytes = new Uint8Array(digest);
	} else {
		const cryptoNode = await import('crypto');
		const buf = cryptoNode.createHash('sha256').update(data).digest();
		bytes = new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
	}
	let binary = '';
	for (let i = 0; i < bytes.length; i++) {
		const byte = bytes[i];
		if (byte !== undefined) {
			binary += String.fromCharCode(byte);
		}
	}
	return btoa(binary)
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
		.replace(/=+$/, '');
}
